// src/components/admin/Loading.js
import React, { useState, useEffect } from 'react';

const Loading = ({ message = "Loading" }) => {
  const [loadingTime, setLoadingTime] = useState(0);
  
  // Track how long we've been loading
  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      setLoadingTime(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="flex flex-col items-center justify-center p-6 space-y-4">
      <div className="w-12 h-12 border-4 border-gray-300 dark:border-gray-600 border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin"></div>
      <p className="text-gray-700 dark:text-gray-300 text-center">
        {message}... {loadingTime > 3 ? `(${loadingTime}s)` : ''}
      </p>
      
      {/* Show a message if loading takes too long */}
      {loadingTime > 10 && (
        <div className="text-center p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md text-yellow-800 dark:text-yellow-300 max-w-xs">
          <p className="mb-1">This is taking longer than expected.</p>
          <p>Try refreshing the page if this persists.</p>
        </div>
      )}
    </div>
  );
};

export default Loading;